<script>
import ProductImage from '@/components/ProductImage'

export default {
  name: 'DatatableBody',

  components: {
    ProductImage,
  },

  props: {
    text: {
      type: [String, Number],
      default: null,
    },

    align: {
      type: String,
      default: 'left',
    },

    bold: {
      type: Boolean,
      default: false,
    },

    variant: {
      type: String,
      default: 'default',
    },

    product: {
      type: Object,
      default: () => ({}),
    },

    image: {
      type: String,
      default: null,
    },
  },

  computed: {
    computedClasses () {
      return {
        [this.$classes['td']]: true,
        [this.$classes['is-bold']]: this.bold,
        [this.$classes['left']]: this.align === 'left',
        [this.$classes['right']]: this.align === 'right',
        [this.$classes['center']]: this.align === 'center',
      }
    },

    productCode () {
      return this.product.id || this.product.CODIGO || ''
    },

    productDescription () {
      return this.product.description || this.product.DESCRICAO_CURTA || ''
    },

    productFactory () {
      return this.product.factory || this.product.MARCA_NOME || ''
    },

    productImage () {
      return this.image || this.product.image || this.product.IMAGEM || ''
    },
  },
}
</script>

<template>
  <td :class="computedClasses" :data-variant="variant">
    <template v-if="variant === 'product-info'">
      <div :class="$classes['product-main-info']">
        <div v-if="productCode" :class="$classes['product-code']">
          Código: {{ productCode }}
          <div v-if="productFactory" :class="$classes['product-brand']">
            {{ productFactory }}
          </div>
        </div>
        <div v-if="productDescription" :class="$classes['product-description']">
          {{ productDescription }}
        </div>
      </div>
      <slot />
    </template>
    <template v-else-if="variant === 'product-image'">
      <div :class="$classes['product-info-with-image']">
        <div v-if="productImage" :class="$classes['product-column']">
          <product-image :src="productImage" :width="100" :height="'auto'" />
        </div>
      </div>
      <slot />
    </template>
    <template v-else>
      <span v-if="text" :class="[$classes['td-text'], {
        [this.$classes['is-bold']]: this.bold
      }]">
        {{ text }}
        <slot name="text" />
      </span>
      <slot />
    </template>
  </td>
</template>

<style module>
.td {
  background: #fff;
  height: 60px;
  padding: 4px;
}

.td-text {
  display: block;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.1em;
  color: #292929;
}

.is-bold {
  font-weight: 600;
}

.left {
  text-align: left;
}

.right {
  text-align: right;
}

.center {
  text-align: center;
}

.product-main-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  cursor: pointer;
}

.product-code {
  font-size: 14px;
  font-weight: 500;
  color: #6c757d;
  font-family: monospace;
}

.product-description {
  margin-top: 4px;
  font-size: 14px;
  font-weight: 600;
  color: #292929;
}

.product-brand {
  font-size: 14px;
  font-weight: 600;
  color: #4A94D4;
  text-transform: uppercase;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Noto Sans", Ubuntu, Cantarell, "Helvetica Neue", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}

.product-info-with-image {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.product-column {
  flex-shrink: 0;
}

.product-message-box {
  margin-top: 8px;
  border-left: 3px solid #2188ff;
  background: #f2f7ff;
  border-radius: 4px;
}

.message-content {
  padding: 8px 10px;
  font-size: 12px;
  color: #1a202c;
}
</style>
